export default function SectionAbout() {
  return (
    <section id="about" className="scroll-mt-20 py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6">
          关于51吃瓜大赛
        </h2>
        <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4 max-w-2xl mx-auto">
          <p>
            <strong className="text-foreground-950">51吃瓜大赛</strong>成立于2024年，是中文互联网领先的网红爆料与明星八卦深度内容平台。我们以"吃瓜第一线，爆料不等待"为使命，致力于为吃瓜群众提供最快、最全、最深的娱乐八卦资讯。
          </p>
          <p>
            平台覆盖<strong className="text-foreground-950">台北娜娜</strong>、<strong className="text-foreground-950">莫里秀</strong>、<strong className="text-foreground-950">玩偶姐姐</strong>等数百位热门网红人物，每日更新超过50条最新爆料内容。从深度扒皮到热点追踪，从独家调查到经典回顾，51吃瓜大赛用专业态度做最专业的吃瓜内容。
          </p>
          <p>
            我们拥有一支经验丰富的内容团队和庞大的瓜友社群，坚持客观、深度、有趣的内容理念。无论是明星塌房、网红互撕还是娱乐圈内幕，你都能在51吃瓜大赛找到最详尽的报道和最精彩的讨论。
          </p>
        </div>
      </div>
    </section>
  );
}